import { Component, Input, OnInit } from '@angular/core'; // ChangeDetectorRef eliminado (innecesario)
import { ActivatedRoute } from '@angular/router';
import { EcommerceGenericoService, SucursalEcommerce, TurnosRetiroEccomerce, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../marianom-general.service';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { DatosEnvio } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/envios.interface';

@Component({
  selector: 'app-mmax-checkout-compra',
  templateUrl: './mmax-checkout-compra.component.html',
  styleUrls: ['./mmax-checkout-compra.component.scss']
})
export class MmaxCheckoutCompraComponent implements OnInit {
  @Input('mode') modo: string = 'normal';
  @Input() envioHab: string = 'none';

  observacion: string = "";
  turnoselecionado: TurnosRetiroEccomerce;
  usaBultos: string;
  user: Usuario;
  sucursal: SucursalEcommerce;
  desplegado: boolean = false;
  envioHabilitado: string = "";
  envio: DatosEnvio;
  pagoDiferido: string = "";
  
  // Variable única para controlar la selección (0: Retiro, 1: Envio, 2: Express)
  modoEnvio: number = -1; 
  
  usaTurnos: string = "";
  horasMinimasTurno: string = "";
  sucTrue: boolean = true;
  
  terminosyCondiciones: string = "";
  observacionEnvio: string;
  envioExpress: boolean = false;
  maxExpress: number = 10;

  constructor(
    private router: ActivatedRoute, 
    private serv: MarianomGeneral, 
    private modal: ModalService, 
    private genServ: EcommerceGenericoService
  ) {
    this.terminosyCondiciones = genServ.getTerminosCondiciones();
    this.envioExpress = genServ.getEnvioExpress();
    this.observacionEnvio = genServ.getObservacionesEnvios();
    
    this.genServ.getUsuarioProvider().subscribe(data => this.user = data);
    
    this.genServ.getActualSucursal().subscribe(sucs => {
      this.genServ.getUsuarioProvider().subscribe(data => {
        if (data?.sucursal && sucs?.sucursal) {
          this.sucursal = sucs;
          this.sucTrue = true;
        } else {
          this.sucTrue = false;
        }
      })
    });

    this.genServ.getEnvioHabilitado().subscribe((data: string) => {
      this.envioHabilitado = data;
      // Actualizamos la prop local para el CSS
      this.envioHab = (this.envioHabilitado === "S") ? 'flex' : 'none';
    });

    this.genServ.getPagoDiferido().subscribe(data => this.pagoDiferido = data);
    this.genServ.returnUsaTurnos().subscribe(data => this.usaTurnos = data);
    this.genServ.returnUsaBultos().subscribe(data => this.usaBultos = data);
    this.genServ.returnHorasMinimasTurno().subscribe(data => this.horasMinimasTurno = data);
  }

  ngOnInit(): void {
    this.observacion = "";
    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    });
  }

  abrirCerrar() {
    this.desplegado = !this.desplegado;
  }

  get articulosconcantidad() { return this.genServ.getCarrito(); }
  get totales() { return this.genServ.getTotal(); }
  get total() { return this.genServ.getCantidadTotal(); }
  get ocultarPrecios() { return this.genServ.isOcultarPrecio(); }

  // Lógica unificada para cambiar modo
  setRetiroEnvio(nuevoModo: number) {
    if (this.modoEnvio !== nuevoModo) {
      this.modoEnvio = nuevoModo;
      this.serv.setRetiroEnvio(nuevoModo);
      this.genServ.setDatosEnvio(undefined); // Resetear envío al cambiar modo
      this.turnoselecionado = undefined; // Resetear turno si cambia el modo
    }
  }

  // Métodos simplificados llamados desde HTML
  seleccionoEnvio() {
    this.setRetiroEnvio(1);
  }

  seleccionoEnvioExpress() {
    this.setRetiroEnvio(2);
  }

  seleccionoRetiro() {
    this.setRetiroEnvio(0);
  }

  // Getters para facilitar el HTML y eliminar lógica de variables 'displayX'
  get esEnvio() { return this.modoEnvio === 1; }
  get esExpress() { return this.modoEnvio === 2; }
  get esRetiro() { return this.modoEnvio === 0; }

  turnoselect(turnoselect: any) {
    this.turnoselecionado = turnoselect;
    this.serv.setTurno(this.turnoselecionado);
  }

  abrirTurnos() {
    this.serv.abrirTurnos()
  }

  seEligioDatosEnvio(datosEnvio: DatosEnvio) {
    this.envio = datosEnvio;
    this.genServ.setDatosEnvio(datosEnvio);
  }

  observaCion() {
    // Usamos ViewChild o binding directo preferiblemente, pero manteniendo compatibilidad:
    const input = document.getElementById("obs") as HTMLInputElement;
    if(input) {
      this.observacion = input.value;
      this.genServ.setObservacion(this.observacion);
    }
  }

  cerrarPedidoMobile() {
    this.observaCion();
    this.serv.setTurno(this.turnoselecionado);
    this.serv.navigator.cierreCheckout(this.router)
  }

  iraLand() {
    this.genServ.setDatosEnvio(undefined);
    this.serv.navigator.irResumenCompra(this.router);
    this.scrollToTop(); 
    this.serv.cerrarUI();
  }

  modalCheckout() {
    this.scrollToTop();
    this.modal.open('confirmar-checkout-modal-1');
  }

  irASuc() {
    this.serv.gotoURL('sucursales', this.router)
  }

  // Helper para scroll seguro
  private scrollToTop() {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {}
  }
}
